import { AuthUser } from 'Components/Common/Util';
import { getLoggedinUser } from '../helpers/api_helper';
import { store } from 'slices/persister';

export const getPrivileges = (): string[] | undefined => {
    const loggedUser = getLoggedinUser();
    const hasMultipleRoles = loggedUser?.userProfile?.roles?.length > 1;
    const selectedRolePrivileges = store.getState()?.SelectedRole?.role?.privileges;
    const privileges = hasMultipleRoles ? selectedRolePrivileges : loggedUser?.userProfile?.roles?.[0]?.privileges;
    return privileges?.map((priv: any) => priv?.replaceAll(' ', '_'));
};

export const IsAuthorized = (privRequired: string): boolean => {
  const user = AuthUser();
  const selectedRole = store.getState()?.SelectedRole?.role;

  const privileges = user?.userProfile?.roles?.length === 1
    ? user?.userProfile?.roles?.[0]?.privileges
    : selectedRole?.privileges;

  return Array.isArray(privileges) && privileges.includes(privRequired);
};

